import { List, ListItem, ListItemIcon, Divider, Zoom, Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { leftNavItems } from 'constants/navigationConstants';
import { $backgroundOffWhite, $bluishGray60, $primary } from 'styles/colors';
import StyledTooltip from 'components/navigation/StyledTooltip';
import AppIconImg from 'assets/images/appLogo.png';
import { handleMenuItemClickEvent } from 'actions/firebase';
import queryString from 'query-string';

const styles = {
	main: {
		width: 75,
		zIndex: 200,
		display: 'flex',
		flexDirection: 'column',
		position: 'fixed',
		left: 20,
		top: 20,
		backgroundColor: $backgroundOffWhite,
		height: 'fit-content',
		padding: '0px 10px',
		borderRadius: '35px'
	},
	logoContainer: {
		height: 100,
		display: 'flex',
		paddingBottom: 20
	},
	list: {
		paddingTop: 20,
		paddingBottom: 20
	},
	listItem: {
		paddingTop: 10,
		paddingBottom: 10,
		display: 'flex',
		justifyContent: 'center',
		height: 61
	},
	listItemIcon: {
		display: 'flex',
		justifyContent: 'center'
	},
	appLogo: {
		borderRadius: '50%',
		cursor: 'default'
	},
	activeIcon: {
		'& svg > path': {
			stroke: $primary
		},
		'& svg > circle': {
			stroke: $primary
		},
		'& svg > rect': {
			fill: $primary,
			stroke: $primary
		}
	},
	inactiveIcon: {
		'& svg > path': {
			stroke: $bluishGray60
		},
		'& svg > circle': {
			stroke: $bluishGray60
		},
		'& svg > rect': {
			fill: $bluishGray60,
			stroke: $bluishGray60
		}
	},
	bottomSection: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: 75,
		paddingLeft: 10,
		paddingRight: 10
	},
	toolTip: {
		padding: 10
	}
};

const SideMenu = () => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();

	const handleClickListItem = item => {
		handleMenuItemClickEvent(item.name);
		let link = item.link;
		if (item.name === 'Submit Data') {
			const queryParams = queryString.parse(window.location.search);
			link = `${item.link}?lat=${queryParams.lat}&long=${queryParams.long}`;
		}
		window.open(link);
	};

	return (
		<Paper elevation={3} className={classes.main}>
			<List className={classes.logoContainer}>
				<ListItem className={classes.listItem}>
					<ListItemIcon className={classes.listItemIcon}>
						<img src={AppIconImg} alt='appIcon' width='60px' />
					</ListItemIcon>
				</ListItem>
			</List>
			<Divider />
			<List className={classes.list}>
				{leftNavItems.map((item, key) => (
					<StyledTooltip
						key={key}
						title={item.name}
						placement={'right'}
						TransitionComponent={Zoom}
						enterDelay={200}
					>
						<ListItem button className={classes.listItem} onClick={e => handleClickListItem(item)}>
							<ListItemIcon className={classes.listItemIcon}>{item.icon}</ListItemIcon>
						</ListItem>
					</StyledTooltip>
				))}
			</List>
		</Paper>
	);
};

export default SideMenu;
